import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import React, { useState, useEffect } from 'react';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import GenericFormContainer from './FormContainer';

interface LoginProps {
    updatecsrf: (value: string) => void;
    updatesession: (value: string) => void;
}

function LoginForm({updatesession}:LoginProps){
    let [username, setUsername] = useState("");
    let [pw, setPW] = useState("");

    const handleSubmit = async (event: React.SubmitEvent) => {
        event.preventDefault();
        
        
        let isSomething = false;
        //Capture session ID and add it to header if it does exist
        //event.preventDefault();

        let axiosConfig = GetHeaders();
        const posturl = process.env.REACT_APP_API_URL + "/v1/user/login"
        const formdata = {username, pw};
        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: formdata})
        console.log("logging in")
        //Handle a Non 200 response
        if(response.status == 200){
            updatesession(response.session_state.session_id);
            window.location.reload();
        }else{
            //Error handling
            console.log(response)
        }
    };

    return (
        <> 
            <GenericFormContainer>
                <Row className="">
                    <Col>
                        <p className="text-start text-font-body text-font-size-large">Sign In</p>
                    </Col>
                </Row>
                <Row className="">
                    <Col>
                        <form onSubmit={handleSubmit}>
                            <Row className="my-2">
                                <Col>
                                    <input placeholder="Username" type="text" className="form-control" id="username" aria-describedby="usernameHelp" onChange={(e) => setUsername(e.target.value)}/>
                                </Col>
                            </Row>
                            <Row className="my-2">
                                <Col>
                                    <input placeholder="Password" type="password" className="form-control" id="password" aria-describedby="passwordHelp" onChange={(e) => setPW(e.target.value)} />
                                </Col>
                            </Row>
                            <button type="submit" className="btn brand-btn-secondary-color w-100 mt-4">Login</button>
                        </form>
                    </Col>
                </Row>
            </GenericFormContainer>
        </>
    )
}
export default LoginForm;